import type { ForgotPasswordState } from '../types';
import messages from './messages';

const validate = (values: ForgotPasswordState, { intl }: Object) => {
  const errors = {};

  if (!values.username) {
    errors.username = intl.formatMessage(messages.requiredFields);
  }

  return errors;
};

export default validate;
